export default __webpack_public_path__ + "static/media/rest4.d5cf021a.jpg";